export const USER_DIVERSITY = [
  'American Indian/Alaska Native',
  'Asian',
  'Black/African American',
  'Hispanic/Latin',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Other',
];

export type UserDiversity = typeof USER_DIVERSITY[number];

export enum Diversity {
  'American Indian/Alaska Native',
  'Asian',
  'Black/African American',
  'Hispanic/Latin',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Other',
}
